import "antd/lib/form/style";
import _Form from "antd/lib/form";
import { connect } from 'dva';
import CI0301C from '../../components/CI/CI0301/index';
function mapDispatchToProps(_ref) {
  var ci0301Info = _ref.ci0301Info;
  return {
    ci0301Info: ci0301Info
  };
}
var CI0301R = _Form.create()(CI0301C);
export default connect(mapDispatchToProps)(CI0301R);